import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, List, Spin, Typography, Button } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useBlogPosts } from "../hooks/useBlogPosts";
import { useFormatDate } from "../hooks/useFormatDate";

const { Text } = Typography;

const BLOG_LIMIT = 5;

export function DashboardBlog() {
  const { t } = useTranslation("translation");
  const formatDate = useFormatDate();
  const { posts, loading } = useBlogPosts({
    publishedOnly: true,
    limit: BLOG_LIMIT,
  });

  if (loading) {
    return (
      <Card size="small" title={<span><FileTextOutlined style={{ marginRight: 8 }} />Blog</span>}>
        <div style={{ textAlign: "center", padding: 16 }}>
          <Spin size="small" />
        </div>
      </Card>
    );
  }

  return (
    <Card
      size="small"
      title={<span><FileTextOutlined style={{ marginRight: 8 }} />Blog</span>}
    >
      {posts.length === 0 ? (
        <Text type="secondary">No posts yet.</Text>
      ) : (
        <List
          size="small"
          dataSource={posts}
          renderItem={(p) => (
            <List.Item style={{ padding: "4px 0", borderBlockEnd: "none" }}>
              <Link
                to={`/blog/${p.id}`}
                style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}
              >
                {p.title}
              </Link>
              <Text type="secondary" style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                {formatDate(p.created_at)}
              </Text>
            </List.Item>
          )}
        />
      )}
      <div style={{ marginTop: 12, textAlign: "right" }}>
        <Link to="/blog">
          <Button type="link" size="small" style={{ padding: 0 }}>
            {t("common.seeAll")}
          </Button>
        </Link>
      </div>
    </Card>
  );
}
